{
  "agb-form": {
    "text": {
      "accept": "Souhlasím se ",
      "agb": "Všeobecné obchodní podmínky"
    }
  }
}
